import styled from 'styled-components'

export const Container = styled.div`
  padding-right: 24px;
`
